import useTranslate from "@hooks/use_translate"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Chip,
  Stack,
  Typography
} from "@mui/material"

const ORDER_KEYS = [
  "ai_engine_order_pin",
  "ai_engine_order_default",
  "ai_engine_order_fallback"
]

const STEP_KEYS = [
  "ai_engine_step_1",
  "ai_engine_step_2",
  "ai_engine_step_3",
  "ai_engine_step_4"
]

/** Plain-language explanation of what this page changes, for an operator who has never seen it. */
export default function HowItWorks() {
  const { translate } = useTranslate()

  return (
    <Accordion defaultExpanded={false} disableGutters>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="subtitle1" fontWeight={600}>
          {translate("ai_engine_how_title")}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Stack gap={2}>
          <Typography variant="body2">
            {translate("ai_engine_how_intro")}
          </Typography>

          <Typography variant="subtitle2">
            {translate("ai_engine_how_order_title")}
          </Typography>
          <Stack direction="row" gap={1} flexWrap="wrap" alignItems="center">
            {ORDER_KEYS.map((key, index) => (
              <Stack key={key} direction="row" gap={1} alignItems="center">
                <Chip size="small" label={`${index + 1}. ${translate(key)}`} />
                {index < ORDER_KEYS.length - 1 && (
                  <Typography variant="body2">→</Typography>
                )}
              </Stack>
            ))}
          </Stack>
          <Typography variant="body2" color="text.secondary">
            {translate("ai_engine_how_order_note")}
          </Typography>

          <Typography variant="subtitle2">
            {translate("ai_engine_how_rollout_title")}
          </Typography>
          <Stack component="ol" gap={0.5} sx={{ pl: 3, m: 0 }}>
            {STEP_KEYS.map((key) => (
              <Typography key={key} component="li" variant="body2">
                {translate(key)}
              </Typography>
            ))}
          </Stack>

          <Typography variant="subtitle2">
            {translate("ai_engine_how_emergency_title")}
          </Typography>
          <Typography variant="body2">
            {translate("ai_engine_how_emergency")}
          </Typography>
        </Stack>
      </AccordionDetails>
    </Accordion>
  )
}
